import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Image, Row, Space, Table } from "antd";
import useLanguage from "../hooks/useLanguage";
import { useLoad } from "../hooks/request";
import { testVenueDelete, testVenueList } from "../utils/url";
import EditDrawerBtn from "../components/Atoms/Buttons/EditDrawerBtn";
import DeleteModalBtn from "../components/Atoms/Buttons/DeleteModalBtn";
import PostDrawerBtn from "../components/Atoms/Buttons/PostDrawerBtn";

export default function TestVenuePage() {
  const getRequest = useLoad({ url: testVenueList });
  const { response, loading } = getRequest;
  const translate = useLanguage();

  const columns = [
    {
      title: "Photo",
      dataIndex: "photo",
      render: (record) => (
        <Row align="middle" justify="center" style={{ width: 120, height: 70 }}>
          <Image
            width="100%"
            height="100%"
            src={record}
            alt="image"
            style={{ objectFit: "cover" }}
          />
        </Row>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      width: 140,
      responsive: ["md"],
      render: (value) =>
        value ? (
          <a href={value} target="_blank" rel="noreferrer">
            View on map
          </a>
        ) : (
          "—"
        ),
    },
    {
      title: "",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space className="crud__actions">
          <EditDrawerBtn
            type={"test-venue"}
            data={record}
            request={getRequest.request}
          />
          <DeleteModalBtn
            url={testVenueDelete}
            id={record._id}
            request={getRequest.request}
          />
        </Space>
      ),
    },
  ];

  return (
    <section className="page">
      <header className="page__header">
        <h1 className="page__title">Test Venues</h1>
        <PostDrawerBtn type={"test-venue"} request={getRequest.request}>
          <AiOutlinePlusCircle className="icon" />
          {translate("add-test-venue")}
        </PostDrawerBtn>
      </header>
      <div className="page__content">
        <Table
          columns={columns}
          dataSource={response?.data?.testVenues}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: 10,
            total: response?.data?.pagination?.total,
            onChange: (page) => {
              getRequest.request({
                url: `${testVenueList}?page=${page}&size=10`,
              });
            },
          }}
          loading={loading}
          rowKey="id"
        />
      </div>
    </section>
  );
}
